import "./SideNav.scss";
import Tabs from "bootstrap-vue/es/components/tabs/tabs";
import Tab from "bootstrap-vue/es/components/tabs/tab";
import BreadcrumbAnchor from "./BreadcrumbAnchor.vue";
import { AppInsights } from "applicationinsights-js";
var SideNav = {
    name: "SideNav",
    extends: Tabs,
    render: function () {
        var vnode = Tabs.render.apply(this, arguments);
        vnode.data.class.push("side-nav");
        return vnode;
    },
    methods: {
        setTab: function () {
            Tabs.methods.setTab.apply(this, arguments);
            var self = this;
            if (!self.isUpdatingTabs) {
                // Find the tab's breadcrumb anchor and set the location hash.
                //
                var tab = self.tabs[self.currentTab];
                var breadcrumb = tab && tab.$el.querySelector(".breadcrumb-anchor[id]");
                if (breadcrumb) {
                    window.location.hash = "#" + breadcrumb.id;
                    // Log to application insights
                    //
                    if (arguments.length === 3) {
                        AppInsights.trackPageView(window.document.title + " (" + breadcrumb.id + ")");
                    }
                }
            }
        },
        updateTabs: function () {
            var self = this;
            self.isUpdatingTabs = true;
            try {
                // If the location has as a hash, find the breadcrumb anchor.
                // If found, set it to active and all the other to not active.
                //
                if (window.location.hash) {
                    var hash_1 = window.location.hash.substr(1);
                    var found_1 = self.tabs.filter(function (p) { return p.$el.querySelector(".breadcrumb-anchor[id='" + hash_1 + "' i]"); })[0];
                    if (found_1) {
                        found_1.localActive = true;
                        self.tabs.filter(function (p) { return p !== found_1; }).forEach(function (p) { return p.localActive = false; });
                    }
                }
                Tabs.methods.updateTabs.apply(this, arguments);
            }
            finally {
                self.isUpdatingTabs = false;
            }
        }
    }
};
var SideNavPage = {
    name: "SideNavPage",
    extends: Tab,
    components: {
        BreadcrumbAnchor: BreadcrumbAnchor
    },
    props: {
        id: {
            type: String
        }
    },
    render: function () {
        var vnode = Tab.render.apply(this, arguments);
        var id = this.id;
        var title = this.title;
        var breadcrumbAnchor = this.$createElement("breadcrumb-anchor", {
            props: {
                id: id,
                title: title,
                linkClass: "side-nav-breadcrumb-item"
            }
        });
        vnode.componentOptions.children[0].children.splice(0, 0, breadcrumbAnchor);
        return vnode;
    }
};
export { SideNav, SideNavPage };



//////////////////
// WEBPACK FOOTER
// ./src/Components/SideNav.ts
// module id = 67
// module chunks = 0 1 2 3 4 6 10 12